import { z } from 'zod';

// https://docs.aws.amazon.com/cognito/latest/developerguide/token-endpoint.html
export const ssoTokenResponseSchema = z.object({
  id_token: z.string(),
  access_token: z.string(),
  refresh_token: z.string().optional(),
});
